import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  openPage(e) {
    Turbo.visit(e.currentTarget.dataset.href)
  }
}
